<template>
  <BootstrapModal
    class="TableSetting"
    :disable-button=true
    :remove-overflow=true
    v-on="$listeners">
    <div>
      <CardTabs
        :tabs="tabs"
        v-model="tabState"
        class="card-tabls" />
      <div class="border-line"></div>
      <div v-if="tabState === 'new-setting'" class="mt-3">
        <FormInput
          class="form-element"
          id="name"
          v-model="$v.name.$model"
          label="Instellingen naam"
          :vuelidate="$v"
          fieldName="name" />

        <div class="modal-footer">
          <span></span>

          <slot name="slot-options">
            <button
              type="button"
              class="btn btn-primary"
              id="submit-button"
              @click="saveSetting"
            >
              <slot name="save"> Opslaan </slot>
            </button>
          </slot>
        </div>
      </div>
      <div v-if="tabState === 'apply-setting'" class="mt-3 FormSelect">
        <FormSearchSelector v-model="setting"
          class="sm form-element website-search"
          id="setting"
          label="Settings"
          placeholder="Zoek setting..."
          endpoint="/api/settings"
          titleField="name"
          searchParameter="name"
          max-height="370px"
          :get-name-from-endpoint="true"
          :table=true
          @select-item="selectSetting"
          :params="params"
          :infinite-scrolling="true"

          v-slot="item"
        >
          <div class="px-2 item">
            {{ item.name }}
          </div>
        </FormSearchSelector>
        <div class="modal-footer">
          <span></span>

          <slot name="slot-options">
            <div>
              <button
              v-show="setting != null"
              type="button"
              class="btn btn-success"
              id="submit-button"
              @click="updateSetting"
            >
              <slot name="save"> Sync </slot>
            </button>
            <button
              v-show="setting != null"
              type="button"
              class="btn btn-danger"
              style="margin-left: 7px"
              id="submit-button"
              @click="removeSetting"
            >
              <slot name="save"> Remove </slot>
            </button>
            <button
              type="button"
              class="btn btn-primary"
              id="submit-button"
              style="margin-left: 7px"
              @click="applySetting"
            >
              <slot name="save"> Apply </slot>
            </button>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </BootstrapModal>
</template>

<script>
import BootstrapModal from "../BootstrapModal.vue"
import FormInput from "src/components/Inputs/FormInput.vue"
import FormSearchSelector from "src/components/Inputs/FormSearchSelector.vue"
import CardTabs from "../../CardTabs.vue"
import { required } from "vuelidate/lib/validators"

export default {
  components: {
    BootstrapModal,
    FormSearchSelector,
    FormInput,
    CardTabs
  },
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: Object
    },
    callback: {
      type: Function,
      required: true
    },
    refetch: {
      type: Function,
      required: false
    }
  },
  validations: {
    name: {
      required
    }
  },
  data() {
    return {
      tabState: 'new-setting',
      setting: null,
      selected: {},
      name: ''
    }
  },
  computed: {
    tabs() {
      return [
        {
          name: "New Setting",
          id: 'new-setting'
        },
        {
          name: "Apply Setting",
          id: 'apply-setting'
        }
      ]
    },
    params() {
      return {
        key: this.id
      }
    },
    storageKeys() {
      return {
        columns: this.id,
        setting: `table-setting:${this.id}`,
        column_sizes: `sizes_storage_key:${this.id}`,
        order: `set_filter_order:${this.id}`,
        sort: `set_filter_sort:${this.id}`
      }
    }
  },
  created() {
    const currentSetting = localStorage.getItem(this.storageKeys.setting)
    if (currentSetting) this.setting = JSON.parse(currentSetting)
  },
  methods: {
    saveSetting() {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        name: this.$v.name.$model,
        key: this.id,
        value: this.value
      }

      this.$handlePromise(async () => {
        await this.axios.post('/api/settings', payload)
      })
      this.$emit('close')

      this.$success("Setting saved succes!")
      this.refetch()
    },
    updateSetting() {
      if (!this.setting) return
      this.$handlePromise(async () => {
        await this.axios.put(`/api/settings/${this.setting}`, { value: this.value })
      })
      this.$success("Setting sync success!")
    },
    removeSetting() {
      if (!this.setting) return
      this.$handlePromise(async () => {
        await this.axios.delete(`/api/settings/${this.setting}`);
      })
      this.$emit('close')
      this.$success("Successfully deleted setting!")
    },
    selectSetting(setting) {
      if (!setting) return
      this.selected = setting.value
    },
    applySetting() {
      if (!this.setting) return
      
      const {
        columns,
        setting,
        column_sizes,
        order,
        sort
      } = this.storageKeys

      this.updateLocalStorage(setting, this.setting)
      if (this.selected.columns) {
        this.updateLocalStorage(columns, this.selected.columns)
      }
      if (this.selected.sizes) {
        this.updateLocalStorage(column_sizes, this.selected.sizes)
      }
      if (this.selected.order) {
        this.updateLocalStorage(order, this.selected.order.type)
        this.updateLocalStorage(sort, this.selected.order.sort)
      }
      this.$emit('close')
      this.$success("Setting applied succes!")
      this.callback(this.selected)
    },
    updateLocalStorage(key, value) {
      localStorage.setItem(key, JSON.stringify(value))
    }
  }
}

</script>

<style>
.FormSelect {
  transform: translateY(-0.5px);
}

.FormSelect select {
  border: 1px solid #bebfc1;
  border-radius: 1px !important;
  height: auto !important;
  padding: 0.4rem 0.5rem !important;
  line-height: 1rem !important;
}

.FormSelect .control-label {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
  margin: 0px !important;
}

.website-search {
  width: 100%;
}

.website-search::v-deep input {
  height: 34px;
}

@media (min-width: 992px) {
  .website-search {
    width: initial;
  }
}

.TableSetting {
  flex-basis: 450px;
}
.modal-header {
  display: flex !important;
  align-items: center !important;
  border-bottom: 1px solid var(--black-20) !important;
}

.modal-header,
.modal-footer,
.modal-body {
  padding: 12px 15px !important;
}

.modal-body {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.modal-footer {
  padding-top: 0px !important;
}

.close-modal {
  filter: brightness(1);
  color: var(--black-70);
  transition-duration: 0.15s;
}

.close-modal:hover {
  filter: brightness(0.5) !important;
}

.modal-title {
  font-size: 1.1825em !important;
}

.removePadding {
  padding-top: 0px;
  padding: 0px !important;
}

.modal-body > div {
  flex-basis: 100%;
  flex-grow: 1;
}
</style>